import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../Translations';
import FlashError from '../components/FlashMessage/FlashError';
import BrandLoader from '../components/BrandLoader';
import NotFound from '../components/NotFound';
import { sessionStore } from './Store';

interface Props {
  children: React.ReactNode;
}

const WhenApplicationSession: React.FC<Props> = ({ children }) => {
  switch (sessionStore.state.kind) {
    case 'requesting':
      return <BrandLoader />;
    case 'present':
    case 'absent':
      return <>{children}</>;
    case 'errored': {
      // Check if current path matches any known valid routes
      const pathname = window.location.pathname;
      const validPaths = ['/logged-out', '/p3'];
      const isKnownRoute = validPaths.some((path) => pathname.startsWith(path));

      // For unknown routes, show the 404 page instead of session error
      if (!isKnownRoute) {
        return <NotFound />;
      }

      // For known routes that failed session, show the session error
      return (
        <div className="flex items-center justify-center h-screen">
          <FlashError>
            <T kind="Unable to establish a session for this application." />
          </FlashError>
        </div>
      );
    }
  }
};

export default observer(WhenApplicationSession);
